import { createFileRoute } from '@tanstack/react-router'
import { PotreePageContainer } from 'pages/pointClouds/PotreePage'
import { pointCloudViewSearchParams } from 'routes/point-cloud/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, pointCloudOrSceneId } = Route.useSearch()

  return (
    <PotreePageContainer
      orgId={orgId}
      siteId={siteId}
      pointCloudOrSceneId={pointCloudOrSceneId}
    />
  )
}

export const Route = createFileRoute('/point-cloud/view')({
  component: RouteComponent,
  validateSearch: pointCloudViewSearchParams,
  staticData: {
    title: 'Point Cloud',
  },
})
